import axios from 'axios'
import AuthToken from '@/auth/auth-token'

class Party {
  constructor () {
    const base = axios.create({
      baseURL: process.env.VUE_APP_CUSTOMER_API,
      withCredentials: false,
      headers: {
        'Content-type': 'application/json'
      }
    })
    this.party = base
  }

  async getUserProfile (email, include_stores = false) {
    await AuthToken.setAuth(this.party, {
      audience: process.env.VUE_APP_CUSTOMER_AUDIENCE
    })
    return this.party({
      url: '/user_profile',
      method: 'GET',
      params: { email, include_stores }
    })
  }
}

export default new Party()


// WEBPACK FOOTER //
// ./src/api/party.js